import _ from "lodash";

// constant
import { INSTANCE_URL, COMMON_MODAL_PAYLOAD } from "@constant";
import { getRequest, postRequest } from "@network";
import { detectBrowser } from "../utils/util-common";

export const EVENT = "EVENT";
export const EVENT_LANGUAGES = "EVENT_LANGUAGES";
export const EVENT_SETTINGS = "EVENT_SETTINGS";
export const EVENT_INTERESTS = "EVENT_INTERESTS";
export const STRIPE_CHARGES_LIST = "STRIPE_CHARGES_LIST";
export const STRIPE_CONNECTION = "STRIPE_CONNECTION";
export const EVENT_APPUSER_COUNT = "EVENT_APPUSER_COUNT";
export const FORCE_REFRESH = "FORCE_REFRESH";
export const COMMON_MODAL = "COMMON_MODAL";

export const checkEvent = (session, seocode, callback) => {
  // seocode = "upcomingrelease";
  let fields =
    "eventid,eventname,eventicon,country,eventstartdate,eventenddate,eventtimezone,seocode,themecolor,iosappstorelink,androidplaystorelink,showconvertedtimezone";
  let related =
    "clients_by_clientidfk,eventsettings_by_eventid&eventsettings_by_eventid.fields=eventpolicytype,allowgroupregistration,allowgroupticket,reg_login_dates&clients_by_clientidfk.fields=clientid,group_number,buildno";
  let filter = encodeURIComponent(`seocode=${seocode}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=${fields}&related=${related}&filter=(${filter})`;

  // console.log("seocode checkEvent: ", seocode);

  return (dispatch) => {
    if (
      session.seocode &&
      session.seocode !== "" &&
      session.seocode.toLowerCase() !== seocode.toLowerCase()
    ) {
      dispatch({
        type: EVENT,
        payload: {},
      });
    }
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource && data.resource.length > 0) {
          // ----- event and event-details set
          dispatch({ type: EVENT, payload: data.resource[0] });

          // ----- event theme color set to root
          // var root = document.querySelector(':root');
          let root = document.documentElement;
          root.style.setProperty("--theme_color", data.resource[0].themecolor);
          root.style.setProperty(
            "--theme_color_light",
            `${data.resource[0].themecolor}dd`
          );

          callback({ success: 1, resource: data.resource[0] });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchEventLanguages = (session, eventid, callback) => {
  let fields = "languagekey,languagetext,languagejson";
  let filter = encodeURIComponent(`(eventid=${eventid})AND(isenabled=1)`);
  let orderBy = encodeURIComponent(`isdefault DESC`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/eventlanguages?fields=${fields}&filter=(${filter})&order=${orderBy}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: EVENT_LANGUAGES, payload: data?.resource ?? [] });
        callback({ success: 1, resource: data?.resource ?? [] });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchEventSettings = (session, callback) => {
  let fields =
    "id,privacy,termsandconditions,thankyoulink,congratulations,supportemail,companyname,companyaddress,autologin,trackingpixel,eventcapacity,waitlistmode,rsvpmultiple,custom_settings,session_settings";
  fields +=
    ",refundpolicy,freeinvoiceattach,paidinvoiceattach,offlinecongratulations,showrefundpolicy,ticketassignflow,islive,ticketreassign,taxname,tax,session_settings";

  let filter = encodeURIComponent(`eventid=${session?.eventid}`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?fields=${fields}&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: EVENT_SETTINGS,
          payload: { data: response?.resource?.[0] },
        });
        callback({
          success: 1,
          data: response?.resource?.[0],
        });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchEventInterests = (session, callback) => {
  let fields = "interestid,eventid,interest";
  let filter = encodeURIComponent(`eventid=${session?.eventid}`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interests?fields=${fields}&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: EVENT_INTERESTS,
          payload: { data: response?.resource },
        });
        callback({ success: 1, data: response?.resource });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchStripeCharges = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/stripe_currency`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: STRIPE_CHARGES_LIST,
          payload: { data: response?.resource },
        });
        callback({ success: 1, data: response?.resource });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchStripeConnection = (session, callback) => {
  let fields = "gateway,stripeaccountid";
  let filter = encodeURI(`eventid=${session?.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/ticket_stripe?fields=${fields}&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: STRIPE_CONNECTION,
          payload: { data: response?.resource?.[0] ?? {} },
        });
        callback({ status: 1, data: response?.resource?.[0] ?? {} });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchAppuserCount = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_public`;
  let body = { ...data, type: "appusercount" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        dispatch({
          type: EVENT_APPUSER_COUNT,
          payload: { data: response },
        });
        callback({ success: 1, data: response });
      },
      (error) => {
        dispatch({ type: EVENT_APPUSER_COUNT, payload: { data: [] } });
        callback({ success: 0, error: error });
      }
    );
  };
};

export const supportTicketRelated = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data, type: "supportticketrelated" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        if (response.success) {
          callback({ success: 1 });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const toggleRefresh = (value) => {
  return (dispatch) => {
    dispatch({ type: FORCE_REFRESH, payload: value });
  };
};

export const contactRelated = (session, data, callback) => {
  let url = `${INSTANCE_URL}/api/v2/ticketrelated`;
  let body = { ...data, type: "contactunsubscribe" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        if (response.success) {
          callback({ success: 1 });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};

export const setCommonModal = (values) => {
  let payload = !_.isEmpty(values) ? values : _.cloneDeep(COMMON_MODAL_PAYLOAD);

  return (dispatch) => {
    dispatch({ type: COMMON_MODAL, payload });
  };
};

export const postAnalytics = (session, payload, callback = () => {}) => {
  const { options, ticketcode, trackingcode } = payload;
  const {
    type,
    dfid = 0,
    screen = "registration",
    associatedid = null,
    searchtext = null,
    hassearchresult = 0,
  } = options;

  const body = {
    ticketcode,
    trackingcode,
    type: "postLinkAnalytics",
    eventid: session.eventid,
    analyticsData: {
      dfid,
      screen,
      type,
      associatedid,
      searchtext,
      hassearchresult,
      eventid: session.eventid,
      data: JSON.stringify({
        ...detectBrowser(),
        eventid: session.eventid,
      }),
    },
  };

  return (dispatch) =>
    postRequest(
      `${INSTANCE_URL}/api/v2/ticketrelated`,
      body,
      session,
      dispatch,
      (response) => callback(response),
      (error) => callback({ success: 0 })
    );
};

export const fetchAssociatedAttendee = (
  session,
  payload,
  callback = () => {}
) => {
  let url = `${INSTANCE_URL}/api/v2/userregistration`;
  let body = { ...payload, type: "fetchassociatedattendee" };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        if (response.success) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: 2 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
};
